var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 pb-5"},[_c('b-container',[(_vm.cartItems.length > 0)?_c('div',{},_vm._l((_vm.cartItems),function(cartItem,idx){return _c('div',{key:idx},[_c('large-cart',{attrs:{"cartItem":cartItem,"idx":idx}})],1)}),0):_c('div',{staticClass:"my-5"},[_c('empty-cart')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }